module.exports = __webpack_public_path__ + "img/billable-rate-icon.392ef16f.svg";